import { ExtThemes, Size, Themes } from '@usitsdasdesign/dds-ng/shared';
import { ToastOptions } from '@usitsdasdesign/dds-ng/toast';
import { TooltipOptions } from '@usitsdasdesign/dds-ng/tooltip';

export class GlobalEngagementsConstant {
  public static readonly UI_ELEMENT_SIZE: Size = Size.lg;
  public static readonly THEME_GREEN: Themes = Themes.green;
  public static readonly EXT_THEME_GREEN: ExtThemes = ExtThemes.green;
  public static readonly THEME_DARK: Themes = Themes.dark;
  public static readonly EXT_THEME_DARK: ExtThemes = ExtThemes.dark;
  public static readonly TEXTAREA_SIZE: string =
    GlobalEngagementsConstant.UI_ELEMENT_SIZE;
  public static readonly DDS_ICON_ARROW_UP: string = 'dds-icon_arrow-up';
  public static readonly DDS_ICON_ARROW_DOWN: string = 'dds-icon_arrow-down';
  public static readonly DDS_ICON_CLOSE: string = 'dds-icon_close';
  public static readonly SELECT_EXISTING_LABEL: string = 'Select existing';
  public static readonly CREATE_NEW_LABEL: string = 'Create new';
  public static readonly NON_CHANGE_ORDER: string = 'nonChangeOrder';
  public static readonly EMPTY_STRING: string = '';
  public static readonly MEMBER_FIRM: string = 'memberFirm';
  public static readonly DELIVERY_CENTER: string = 'deliveryCenter';
  public static readonly OFFERING: string = 'offering';
  public static readonly OFFERING_PORTFOLIO: string = 'offeringPortfolio';
  public static readonly START_DATE: string = 'startDate';
  public static readonly END_DATE: string = 'endDate';
  public static readonly ENGAGEMENT_TITLE: string = 'engagementTitle';
  public static readonly OPPORTUNITY: string = 'opportunity';
  public static readonly DEFAULT_VALUE: string = '-';
  public static readonly undefinedString: string = 'undefined';
  public static readonly nullString: string = 'null';
  public static readonly validationConstant: string = 'Validation';
  public static readonly PresignedURL: string = 'PresignedURL';
  public static readonly PresignedURLUpdated: string = 'PresignedURLUpdated';
  public static readonly uploaded: string = 'uploaded';
  public static readonly DATE_FORMAT: string = 'MM/dd/yyyy';
  public static readonly NO_MATCHES_FOUND: string = 'No matches found';
  public static readonly REMOVE_OPPORTUNITY_TEXT: string =
    'Cancel and select a new opportunity';

  public static readonly PAGE_NUMBER: number = 15;
  public static readonly TOOLTIP_WIDTH: number = 450;
  public static readonly memberFirmOther: number = 27;
  public static readonly longOldDate: number = -5000000000000;
  public static readonly longNewDate: number = 5000000000000;
  public static readonly SEARCH_LIMIT: number = 3;
  public static readonly TEXT_LENGTH_1000: number = 1000;
  public static readonly TEXT_LENGTH_100: number = 100;
  public static readonly TIMEOUT_TIMER: number = 2500;
  public static readonly otherType: number = 4;
  public static readonly archivedStatus: number = 1;
  public static readonly DELAY_TIMER: number = 3000;
  public static readonly SEARCH_STRING_LIMIT_2: number = 2;
  public static readonly SEARCH_DEBOUNCE_TIME: number = 500;
  public static readonly RESET_ACTION_ID: number = 1;

  public static readonly TOAST_OPTIONS: ToastOptions = {
    title: GlobalEngagementsConstant.EMPTY_STRING,
    message: GlobalEngagementsConstant.EMPTY_STRING,
    lifeTime: 3000,
    withProgressBar: false,
    position: 'bottom-center',
    isCloseIcon: false,
    customClass: 'toast-align simple-toast',
    isError: false,
    isInverse: false,
    isLoading: false,
    limit: 5,
    theme: GlobalEngagementsConstant.THEME_DARK,
  };

  public static readonly TOOLTIP_OPTIONS: TooltipOptions = {
    tooltipInvokeType: 'hover',
    tooltipPosition: 'top',
    tooltipIndent: 15,
    tooltipIsOutsideClick: false,
    tooltipHasBeak: true,
    tooltipIsDisabled: false,
    tooltipIsInverse: false,
    tooltipIsDynamic: false,
    tooltipCustomClass: GlobalEngagementsConstant.EMPTY_STRING,
    tooltipType: 'regular',
    tooltipSize: 'md',
    tooltipShowDelay: 0,
    tooltipHideDelay: 0,
    tooltipTheme: Themes.dark,
    tooltipMaxWidth: 300,
  };
}

export enum EngagementStatus {
  Draft = 1,
  Completed = 2,
  Discontinued = 3,
  CompletedAdmin = 4,
}
export enum TabHeaders {
  SubmissionDetails = 'Submission details',
  Documents = 'Documents',
  Notes = 'Notes/feedback',
  Workflow = 'Workflow',
  CommunicationAttributes = 'Communication attributes',
  InternalQRMTeamCommunication = 'Internal QRM team communication',
  RiskAssessment = 'Risk assessment',
}

export function getStatusEnumKeyByValue(value: number): string | undefined {
  return Object.keys(EngagementStatus).find(
    (key) => EngagementStatus[key as keyof typeof EngagementStatus] === value
  );
}